import { useState } from "react";
import axios from "axios";
import { CalendlyEmbed } from "./CalendlyEmbed";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const InquiryForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | submitting | done | error

  const validate = () => {
    const e = {};
    if (!name.trim()) e.name = "Please share your name.";
    if (!email.trim()) e.email = "Please share your email.";
    else if (!EMAIL_RE.test(email.trim())) e.email = "That email does not look right.";
    if (!message.trim()) e.message = "A few words, please.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setStatus("submitting");
    try {
      await axios.post(`${API}/inquiries`, {
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim() || null,
        message: message.trim(),
      });
      setStatus("done");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  if (status === "done") {
    return (
      <div data-testid="post-submit-panel" className="w-full">
        <p
          data-testid="thank-you-message"
          className="font-serif-display text-2xl md:text-3xl leading-snug"
          style={{ color: "var(--fs-slate)" }}
        >
          Thank you. I have your note. Choose a time below and we will meet.
        </p>
        <div className="mt-10 md:mt-14">
          <CalendlyEmbed name={name.trim()} email={email.trim()} />
        </div>
      </div>
    );
  }

  return (
    <form
      data-testid="inquiry-form"
      onSubmit={onSubmit}
      noValidate
      className="w-full"
      style={{
        background: "var(--fs-clay-deep)",
        padding: "clamp(28px, 5vw, 56px)",
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
        <div>
          <label htmlFor="fs-name" className="fs-field-label">Name</label>
          <input
            id="fs-name"
            data-testid="inquiry-name"
            type="text"
            className="fs-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="name"
            required
          />
          {errors.name && <div data-testid="error-name" className="fs-field-error">{errors.name}</div>}
        </div>

        <div>
          <label htmlFor="fs-email" className="fs-field-label">Email</label>
          <input
            id="fs-email"
            data-testid="inquiry-email"
            type="email"
            className="fs-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
          {errors.email && <div data-testid="error-email" className="fs-field-error">{errors.email}</div>}
        </div>

        <div className="md:col-span-2">
          <label htmlFor="fs-phone" className="fs-field-label">Phone (optional)</label>
          <input
            id="fs-phone"
            data-testid="inquiry-phone"
            type="text"
            className="fs-input"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            autoComplete="tel"
          />
        </div>

        <div className="md:col-span-2">
          <label htmlFor="fs-message" className="fs-field-label">Your note</label>
          <textarea
            id="fs-message"
            data-testid="inquiry-message"
            rows={5}
            className="fs-textarea"
            placeholder="What are you building? Who is it for? Where do you feel stuck or uncertain?"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          {errors.message && <div data-testid="error-message" className="fs-field-error">{errors.message}</div>}
        </div>
      </div>

      <div className="mt-10 md:mt-14 flex items-center gap-6">
        <button
          type="submit"
          data-testid="inquiry-submit"
          className="fs-btn"
          disabled={status === "submitting"}
        >
          {status === "submitting" ? "Sending" : "Send"}
        </button>
        {status === "error" && (
          <span data-testid="submit-error" className="fs-field-error" style={{ marginTop: 0 }}>
            Something went wrong. Please try again.
          </span>
        )}
      </div>
    </form>
  );
};

export default InquiryForm;
